export default __webpack_public_path__ + "static/media/user_activity_37.854e455e.png";